import {Component, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {BaseModalComponent} from '../base-modal.component';
import {PickupLocation} from '../../_models/pickup-location';

@Component({
    selector: 'bb-select-pickup-location',
    templateUrl: './select-pickup-location.component.html',
    styleUrls: ['./select-pickup-location.component.scss'],
})
export class SelectPickupLocationComponent extends BaseModalComponent {
    @Input() pickupLocations: PickupLocation[];
    @Input() selected: PickupLocation;

    constructor(
        modalController: ModalController
    ) {
        super(modalController);
    }
}
